/* Arctic Acres motion layer.
   - Scroll-reveal for .reveal / .reveal-stagger
   - Count-up for [data-count-to] figures (only while on screen, so a value never
     stays stuck at 0 where the visitor can see it)
   - window.AA.countTo() helper so the configurators can animate their live total
   Uses a rAF-throttled scroll check (works in every browser / embedded viewport).
   Skipped entirely under prefers-reduced-motion; markup stays fully visible without JS. */
(function () {
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduce = !!(mq && mq.matches);

  // Parse a number that may use a Unicode minus (U+2212) or thousands separators.
  function num(v) { return parseFloat(String(v == null ? '' : v).replace(/−/g, '-').replace(/,/g, '')); }

  function fmt(el, n) {
    var dec = parseInt(el.getAttribute('data-count-decimals') || '0', 10);
    var pre = el.getAttribute('data-count-prefix') || '';
    var suf = el.getAttribute('data-count-suffix') || '';
    // Grouping OFF by default so years render "2019" not "2,019"; opt in with data-count-group="true".
    var group = el.getAttribute('data-count-group') === 'true';
    var s = Number(n).toLocaleString('en-CA', { minimumFractionDigits: dec, maximumFractionDigits: dec, useGrouping: group });
    if (n < 0 && /−/.test(el.getAttribute('data-count-to') || '')) s = s.replace('-', '−');
    return pre + s + suf;
  }

  // Public helper: animate el's text from its stored value to `to`, formatting with formatFn.
  window.AA = window.AA || {};
  window.AA.countTo = function (el, to, formatFn, dur) {
    if (!el) return;
    formatFn = formatFn || function (v) { return String(Math.round(v)); };
    if (reduce) { el.textContent = formatFn(to); el.setAttribute('data-cur', to); return; }
    var from = num(el.getAttribute('data-cur'));
    if (isNaN(from)) from = to;
    dur = dur || 480;
    var start = null;
    (function frame(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = formatFn(from + (to - from) * eased);
      if (p < 1) requestAnimationFrame(frame);
      else { el.textContent = formatFn(to); el.setAttribute('data-cur', to); }
    })(performance.now());
  };

  // (Header shadow-on-scroll is handled inside the header section itself.)

  if (reduce) return;
  document.documentElement.classList.add('aa-reveal-ready');

  function vh() { return window.innerHeight || document.documentElement.clientHeight || 0; }
  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < vh() * 0.92 && r.bottom > 0;
  }
  // Fail-safe: if the viewport can't be measured (0 height), never leave content hidden.
  function revealAll() {
    document.querySelectorAll('.reveal:not(.in), .reveal-stagger:not(.in)').forEach(function (el) { el.classList.add('in'); });
    document.querySelectorAll('[data-count-to]').forEach(function (el) {
      if (el.getAttribute('data-counted') !== 'done') { el.setAttribute('data-counted', 'done'); el.textContent = fmt(el, num(el.getAttribute('data-count-to'))); }
    });
  }

  function runCount(el) {
    var target = num(el.getAttribute('data-count-to'));
    if (isNaN(target)) { el.setAttribute('data-counted', 'done'); return; }
    var from = num(el.getAttribute('data-count-from') || '0');
    var dur = parseInt(el.getAttribute('data-count-dur') || '1100', 10);
    var start = null;
    (function frame(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(el, from + (target - from) * eased);
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = fmt(el, target);
    })(performance.now());
  }

  var ticking = false;
  function check() {
    ticking = false;
    if (!vh()) { revealAll(); return; }   // degenerate viewport -> show everything, no animation
    document.querySelectorAll('.reveal:not(.in), .reveal-stagger:not(.in)').forEach(function (el) {
      if (inView(el)) el.classList.add('in');
    });
    document.querySelectorAll('[data-count-to]').forEach(function (el) {
      var state = el.getAttribute('data-counted');
      if (state === 'done') return;
      if (!state) { el.setAttribute('data-counted', 'seed'); el.textContent = fmt(el, num(el.getAttribute('data-count-from') || '0')); }
      if (inView(el)) { el.setAttribute('data-counted', 'done'); runCount(el); }   // only animate on screen
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  check();

  // Re-run when content or sections change (Shopify theme editor, dynamic renders).
  if (window.MutationObserver) {
    new MutationObserver(function () { requestAnimationFrame(check); }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', check);

  // Safety net: if the page never scrolls, still resolve any count that is on screen.
  if (window.addEventListener) window.addEventListener('load', check);

  // Animated <details> accordions (FAQ etc.) — smooth height + fade on open/close.
  function initAccordions() {
    document.querySelectorAll('details.aa-faq__item > summary:not([data-acc])').forEach(function (summary) {
      summary.setAttribute('data-acc', '1');
      var details = summary.parentElement;
      var panel = details.querySelector('.aa-faq__a');
      if (!panel) return;
      var DUR = 260;
      summary.addEventListener('click', function (e) {
        if (reduce) return; // native instant toggle under reduced-motion
        e.preventDefault();
        if (panel.dataset.animating) return;
        panel.dataset.animating = '1';
        if (details.open) {
          panel.style.height = panel.scrollHeight + 'px';
          void panel.offsetHeight;            // commit current height
          panel.style.height = '0px'; panel.style.opacity = '0';
          setTimeout(function () { details.open = false; panel.style.height = ''; panel.style.opacity = ''; delete panel.dataset.animating; }, DUR);
        } else {
          details.open = true;                // display:block so content lays out
          var target = panel.scrollHeight;    // measure full height after layout
          panel.style.height = '0px'; panel.style.opacity = '0';
          void panel.offsetHeight;            // commit height:0
          panel.style.height = target + 'px'; panel.style.opacity = '1';
          setTimeout(function () { panel.style.height = 'auto'; delete panel.dataset.animating; }, DUR);
        }
      });
    });
  }
  initAccordions();
  document.addEventListener('shopify:section:load', initAccordions);

  /* Configurator price bar: tuck it away when the footer comes into view, so the persistent
     bottom bar never sits on top of the footer. Purely additive; the bar works without it. */
  function initPricebarTuck() {
    var bar = document.querySelector('.aa-pricebar');
    var footer = document.querySelector('.aa-ft');
    if (!bar || !footer || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-tucked', entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -24px 0px' }).observe(footer);
  }
  initPricebarTuck();
  document.addEventListener('shopify:section:load', initPricebarTuck);

  /* Option info tooltips. The bubble is position:fixed, so its coordinates are set here from
     the icon's rect (above it, flipping below when there is no room). A tap toggles it and is
     stopped from also toggling the option card the icon sits inside. */
  function initHelpTips() {
    document.querySelectorAll('.aa-help[data-help]').forEach(function (help) {
      if (help.dataset.helpReady) return;
      help.dataset.helpReady = '1';
      var bubble = help.querySelector('.aa-help__bubble');
      if (!bubble) return;
      function place() {
        var r = help.getBoundingClientRect();
        var bw = bubble.offsetWidth, bh = bubble.offsetHeight;
        // Clamp to the visible content width (excludes any classic scrollbar) so the
        // bubble never spills past the right edge on desktop or narrow phones.
        var vw = document.documentElement.clientWidth || window.innerWidth;
        var left = Math.max(8, Math.min(r.left + r.width / 2 - bw / 2, vw - bw - 8));
        var top = r.top - bh - 8;
        if (top < 8) top = r.bottom + 8; // flip below the icon if there is no room above
        bubble.style.left = left + 'px';
        bubble.style.top = top + 'px';
      }
      function show() {
        // Move the bubble to <body> before showing. It is position:fixed, so any
        // transformed/filtered ancestor (e.g. a .reveal column) would otherwise become
        // its containing block and throw the placement hundreds of px off.
        if (bubble.parentElement !== document.body) document.body.appendChild(bubble);
        bubble.classList.add('is-shown');
        place();
      }
      function hide() { bubble.classList.remove('is-shown'); }
      help.addEventListener('mouseenter', show);
      help.addEventListener('mouseleave', hide);
      help.addEventListener('focus', show);
      help.addEventListener('blur', hide);
      help.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (bubble.classList.contains('is-shown')) hide(); else show();
      });
      help.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); if (bubble.classList.contains('is-shown')) hide(); else show(); }
        else if (e.key === 'Escape') hide();
      });
    });
  }
  // Close any open bubble when tapping elsewhere.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.aa-help')) return;
    document.querySelectorAll('.aa-help__bubble.is-shown').forEach(function (b) { b.classList.remove('is-shown'); });
  });
  // A shown bubble is placed once; close it on scroll rather than let it drift from its icon.
  window.addEventListener('scroll', function () {
    document.querySelectorAll('.aa-help__bubble.is-shown').forEach(function (b) { b.classList.remove('is-shown'); });
  }, { passive: true });
  initHelpTips();
  document.addEventListener('shopify:section:load', initHelpTips);
})();

/* ---------------------------------------------------------------------------
   Scroll lock for popups, shared.

   Exposed on window because more than one thing needs it: the dialogs here and
   the header drawer, which used to set body.style.overflow itself and so could
   release the lock while a dialog on top of it was still open.

   Counted rather than boolean for that same reason. Two things open means two
   locks, and the page only moves again when the second one closes.

   Any <dialog> is picked up automatically by watching its open attribute, so a
   popup added later is covered without being registered anywhere.
--------------------------------------------------------------------------- */
(function () {
  var depth = 0;

  function lock() {
    if (depth++ > 0) return;
    // Width of the scrollbar about to disappear. Zero on overlay scrollbars.
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--aa-sbw', (sbw > 0 ? sbw : 0) + 'px');
    document.body.classList.add('aa-locked');
  }

  function unlock() {
    depth -= 1;
    if (depth > 0) return;
    depth = 0;
    document.body.classList.remove('aa-locked');
    document.documentElement.style.removeProperty('--aa-sbw');
  }

  window.aaScrollLock = { lock: lock, unlock: unlock };

  function watch(dlg) {
    if (dlg.dataset.aaLockReady) return;
    dlg.dataset.aaLockReady = '1';
    if (dlg.open) lock();
    // The open attribute is the one signal every route to opening shares:
    // showModal(), show(), or markup that ships with it already set.
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        if (r.attributeName !== 'open') return;
        if (dlg.hasAttribute('open')) lock(); else unlock();
      });
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
  }

  function scan() { document.querySelectorAll('dialog').forEach(watch); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
